import React, { useState } from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Icon } from '@vio/atlas/Icon';
const UnstyledButton = /*#__PURE__*/styled('button')({
  name: "UnstyledButton",
  class: "u1a3c5h5",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => Flex.Row;
const Wrapper = /*#__PURE__*/styled(_exp())({
  name: "Wrapper",
  class: "w1bv2wta",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => Icon;
const StyledIcon = /*#__PURE__*/styled(_exp3())({
  name: "StyledIcon",
  class: "s1wrl5yz",
  propsAsIs: true
});
type StarRatingProps = {
  totalStars: number;
  onRateChange: (value) => void;
};
export const StarRating = ({
  totalStars,
  onRateChange
}: StarRatingProps) => {
  const [rating, setRating] = useState(0);
  const handleClick = star => {
    setRating(star);
    onRateChange(star);
  };
  return <Wrapper gap="s400">
      {[...Array(totalStars)].map((_, index) => {
      const starValue = index + 1;
      return <UnstyledButton key={`star-${index}`} onClick={() => handleClick(starValue)}>
            <StyledIcon size="xl" name={starValue <= rating ? 'StarSolid' : 'StarOutline'} colorPath="background.warning.c500" />
          </UnstyledButton>;
    })}
    </Wrapper>;
};

require("./StarRating.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./StarRating.tsx");